import http from '@/communication/AuthConnection'

export default async ({ commit }, payload) => {
  try {
    const request = await http.patch('/v1/board/responsible/add', payload)
    return request.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/board/add-responsible-user/index.js